import { render } from "./insure-team-report.vue?vue&type=template&id=8251daaa&scoped=true&ts=true"
import script from "./insure-team-report.vue?vue&type=script&lang=ts"
export * from "./insure-team-report.vue?vue&type=script&lang=ts"

import "./insure-team-report.vue?vue&type=style&index=0&id=8251daaa&lang=stylus&scoped=true"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8251daaa"]])

export default __exports__